import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Cut } from '../../../../models/cut';
import { selectUser } from '../../../../features/user/user.selectors';
import { Observable } from 'rxjs';
import { selectCutById } from '../../../../features/cut/cut.selectors';


@Component({
    selector: 'cut-card',
    templateUrl: './cut-card.component.html',
    styleUrls: ['../card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CutCardComponent {

  private _cutId!: string;

  @Input({ required: true })
  set cutId(value: string) {
    this._cutId = value;
    this.cut$ = this.store.select(selectCutById(value));
  }
  cut$!: Observable<Cut | undefined>;

  readonly currentUser$ = this.store.select(selectUser);

  constructor(private store: Store) {
  }

}
